import React from 'react';
import './PrivacyPoliticy.css';
import SolutionImg from '../../assets/images/Image.png';

function PrivacyPolicy() {
    return (
        <div className="container privacyPolicy mb-5">
            <div className="solution__hero">
                <div className='container d-flex justify-content-between'>
                    <div className="solution__hero-text d-flex justify-content-start align-items-center">
                        <h1>Politique et confidentialité</h1>
                    </div>
                    <div className="solution__hero-img">
                        <img src={SolutionImg} alt="image data 360 degree" />
                    </div>
                </div>
            </div>

            <div className='privacyPolicy__title p-4 d-flex justify-content-center align-items-center'>
                <h1>Politique de confidentialité</h1>
            </div>

            <div className='PrivacyPolicy__content display-flex-center flex-column gap-3'>
                <div className='mb-3'>
                    <span className=''>Dernière mise à jour : Avril 2025</span>
                </div>

                <div className='PrivacyPolicy__content-text text-justify'>
                    <p > Bienvenue sur le site de Data360degree.</p>
                    <p> En tant qu’entreprise spécialisée en recherche marketing, études de données et conseil stratégique, Data360degree attache  <br /> une grande importance à la protection de vos informations personnelles ainsi qu’à la transparence de nos pratiques. <br /> Nous nous engageons  à traiter les données de nos visiteurs, partenaires et clients avec le plus grand soin, dans le respect des <br /> lois en vigueur.</p> 
                    <p>Cette politique de confidentialité visent à vous informer clairement sur les données que nous <br /> collectons,
                        les raisons de cette collecte, la manière dont elles sont utilisées, et les droits dont vous disposez.
                    </p>
                    <p>Nous vous remercions pour votre confiance et restons à votre disposition pour toute question ou demande complémentaire. </p>
                    <p>— L’équipe Data360degree</p>
                </div>

                <div>
                    <h2>A. Données que nous collectons</h2>
                </div>

                <div>
                    <h3>1. Pour les visiteurs du site :</h3>
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Données via formulaires (nom, email, téléphone...)</li>
                    <li>Données techniques (IP, navigateur, pages visitées...)</li>
                </ul>
                <h3>2. Pour nos clients professionnels :</h3>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Données d'enquêtes terrain, études</li>
                    <li>Données CRM ou internes</li>
                    <li>Données hébergées chez le client</li>
                </ul>
                <h2>B. Utilisation des données</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Pour les visiteurs : répondre, informer, améliorer l'expérience</li>
                    <li>Pour les clients : exécution de mission, reporting, support</li>
                </ul>
                <h2>C. Base légale du traitement</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Consentement</li>
                    <li>Exécution contractuelle</li>
                    <li>Obligations légales</li>
                    <li>Intérêts légitimes</li>
                </ul>
                <h2>D. Partage et accès aux données</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Partenaires techniques</li>
                </ul>
                <h2>E. Sécurité des données</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Sécurisation des échanges, accès limité, sauvegardes, audits.</li>
                </ul>
                <h2>F. Conservation des données</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Selon durée utile ou contractuelle. Données supprimées ou restituées après projet.</li>
                </ul>
                <h2>G. Vos droits</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Accès, rectification, opposition, suppression, portabilité.</li>
                    <li>Contact : privacy@data360degree.net</li>
                </ul>
                <h2>H. Mineurs</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Site et services non destinés aux moins de 18 ans.</li>
                </ul>
                <h2>I. Contact</h2>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Data360degree</li>
                    <li>Kinshasa – RDC.</li>
                    <li>privacy@data360degree.net</li>
                </ul>
            </div>
        </div>
    );
}
export default PrivacyPolicy;